import React, { Component } from 'react';

import { Link } from "react-router-dom";
import { withRouter } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import './Home.css';

import '../config.js';

const restServer = global.restServer;

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {idValue: '', seqValue:'', results: null, stats:{}};
    
        this.changeId = this.changeId.bind(this);
        this.submit4IdSearch = this.submit4IdSearch.bind(this);
        this.changeSeq = this.changeSeq.bind(this);
        this.submit4SeqSearch = this.submit4SeqSearch.bind(this);
   
    }

    componentDidMount() {
        const url = [restServer, 'stats'].join("/");
        fetch(url)
        .then(response => response.json())
        .then(data => this.setState({stats: data}));
    }

    submit4IdSearch(event) {
        event.preventDefault();
        const url = process.env.PUBLIC_URL + '/search?t=txt;q=' + this.state.idValue;
        this.props.history.push(url);
    }

    submit4SeqSearch(event) {
        event.preventDefault();
        const url = process.env.PUBLIC_URL + '/search?t=txt;q=' + this.state.seqValue;
        this.props.history.push(url);   
    }

    changeId(event) {
        this.setState({idValue: event.target.value});
    }

    changeSeq(event) {
        this.setState({seqValue: event.target.value});
    }

    render() {
        let release_date = "2019-09-11";
        let domains = "40,460";
        let structures = "162,150";
        if (this.state.stats) {
            const rest_stats = this.state.stats.stats || {};
            domains = rest_stats.domains || domains;
            structures = rest_stats.structures || structures; 
            release_date = rest_stats.release_date || release_date; 
        }
        const about_link = process.env.PUBLIC_URL + '/about';
        //console.log(this.state);
        return (
            <div>
                <div id="legacy">The legacy SCOP dataset can be accessed at <a target="_ext_link" href="https://ftp.ebi.ac.uk/pub/databases/pdbe-kb/scop-legacy/">SCOP 1.75</a> and <a target="_ext_link" href="http://scop.mrc-lmb.cam.ac.uk/scop2">SCOP2 prototype</a></div>   
                <div id="description">
                    <div id="headline">SCOP 2</div>  
                    <button className="learn" type="button" onClick={() =>this.props.history.push(about_link)}>
    Learn More
  </button>
                    <div id="title">SCOP: Structural Classification of Proteins</div>
                    <div id="info">
                    Nearly all proteins have structural similarities with other proteins and, 
                    in some of these cases, share a common evolutionary origin. The SCOP database, 
                    created by manual inspection and abetted by a battery of automated methods, 
                    aims to provide a detailed and comprehensive description of the structural and 
                    evolutionary relationships between all proteins whose structure is known. 
                    As such, it provides a broad survey of all known protein folds, detailed information 
                    about the close relatives of any particular protein, and a framework for future 
                    research and classification.
                    </div>
                    <div id="release-info">
                    Latest update on <span className="ht-red"> {release_date} </span> includes <span className="ht-red"> {domains} </span>
                     non-redundant domains representing <span className="ht-red"> {structures} </span> protein structures. 
Folds, superfamilies and families statistics <Link to={`${process.env.PUBLIC_URL}/stats`}>here</Link>.
                    </div>
                </div>
                <div id="search">
                    <Tabs className="myClass" defaultActiveKey="idsearch" id="searachtab">
                        <Tab  className="myTab" eventKey="idsearch" title="Keyword and ID search">
                        <Form onSubmit={this.submit4IdSearch}>
                            <div  className="form-inline">
                            <FormControl onChange={this.changeId} id="idsearchbox" type="text" placeholder="Enter free text, SCOP ID, PDB ID or UniProt ID" />
                            <button type="submit" className="go">Go</button>
                            </div>
                        </Form>
                         </Tab>
                       <Tab eventKey="seqseach" title="Sequence search" disabled>
                       <Form onSubmit={this.submit4SeqSearch}>
                            <div  className="form-inline">
                            <FormControl onChange={this.changeSeq} id="seqsearchbox" as="textarea" type="text" rows="5" cols="60" placeholder="Enter protein sequence" className="mr-sm-2" />
                            <button className="go" type="submit">Go</button>
                            </div>
                            </Form>
                         </Tab>
                    </Tabs>
                </div>
                <div id="browse">
                    <Proteins by="class" />
                    <div className="spacer"></div>
                    <Proteins by="type" />
                </div>
                <div id="cite">
                    Please cite: <a href="https://doi.org/10.1093/nar/gkt1242">Antonina Andreeva, 
                    Dave Howorth, Cyrus Chothia, Eugene Kulesha, Alexey Murzin, SCOP2 prototype: 
                    a new approach to protein structure mining. (2014) Nucl. Acid Res., 42 (D1): D310-D314</a> and <a href="https://doi.org/10.1093/nar/gkz1064">Antonina Andreeva, Eugene Kulesha, Julian Gough, Alexey Murzin, 
                    The SCOP database in 2020: expanded classification of representative family and superfamily domains of known protein 
                    structures. (2020) Nucl. Acid Res., 48 (D1): D376-D382</a>

                </div>
            </div>
        );
    }   
}

export default withRouter(Home);

function Proteins(props) {
    const proteinLists = {
        'class' : [
            {'id' : 1000000, 'name': 'All alpha proteins'},
            {'id' : 1000001, 'name': 'All beta proteins'},
            {'id' : 1000002, 'name': 'Alpha and beta proteins(a/b)'},
            {'id' : 1000003, 'name': 'Alpha and beta proteins(a+b)'},
            {'id' : 1000004, 'name': 'Small proteins'}
        ],
        'type' : [
            {'id' : 1, 'name' : 'Globular proteins'},
            {'id' : 2, 'name' : 'Membrane proteins'},
            {'id' : 3, 'name' : 'Fibrous proteins'},
            {'id' : 4, 'name' : 'Non-globular/Intrinsically unstructured proteins'}
        ]
    }


    let items = proteinLists[props.by];
    let sw = props.by === 'class' ? 'structural class' : 'protein type';

    return(
        <div className="browse-proteins">
            <div className="panel-title">Browse by {sw}</div>
            <ul>
                {items.map((item) => (
                    <li key={"li_"+item.id}><Link to={`${process.env.PUBLIC_URL}/term/`+item.id}>{item.name}</Link></li>
                ))}
            </ul>
        </div>
    )
}
